module.exports = __webpack_public_path__ + "img/pos.0073281d.png";